import { render, staticRenderFns } from "./PositionAssignment.vue?vue&type=template&id=8ef85cee"
import script from "./PositionAssignment.vue?vue&type=script&lang=js"
export * from "./PositionAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports